import { c as _c } from "react/compiler-runtime";
import { Divider, Form } from '@onefootprint/ui';
import Link from 'next/link';
import { useWatch } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import Section from '@/playbook-builder/components/section';
import type { FormIdentityData } from '../../collect-data-node/components/person/person.types';
import VerifiedPrefillChallengeKind from '../../shared/verified-prefill-challenge-kind';
import VerifiedPrefillOutputs from '../../shared/verified-prefill-outputs';
type VerifiedPrefillSectionProps = {
  canEdit: boolean;
  isFirmEmployee: boolean;
};
export const VerifiedPrefillSection = t0 => {
  const $ = _c(23);
  const {
    canEdit,
    isFirmEmployee
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "collectData.person.verifiedPrefill"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      name: "enabledVerifiedPrefill"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const enabledVerifiedPrefill = useWatch(t2);
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      name: "skipIfSsnPopulated"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const skipIfSsnPopulated = useWatch(t3);
  let t4;
  if ($[3] !== t) {
    t4 = t(_temp);
    $[3] = t;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = !canEdit;
  let t6;
  if ($[5] !== t) {
    t6 = t(_temp2);
    $[5] = t;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5 || $[8] !== t6) {
    t7 = <Form.Toggle disabled={t5} name="enabledVerifiedPrefill" label={t6} size="compact" />;
    $[7] = t5;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="text-caption-2 text-tertiary"><Trans ns="playbook-builder" i18nKey={_temp3} components={{
        verifiedLink: <Link href="https://verified.inc" target="_blank" className="text-accent" rel="noopener noreferrer" />
      }} /></p>;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== t7) {
    t9 = <div className="flex flex-col gap-2">{t7}{t8}</div>;
    $[11] = t7;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== canEdit || $[14] !== enabledVerifiedPrefill || $[15] !== isFirmEmployee || $[16] !== skipIfSsnPopulated || $[17] !== t) {
    t10 = enabledVerifiedPrefill && <><Divider /><VerifiedPrefillChallengeKind canEdit={canEdit} isFirmEmployee={isFirmEmployee} /><div className="flex flex-col gap-3"><Form.Toggle name="skipIfSsnPopulated" label={t(_temp4)} size="compact" hint={t(_temp5)} disabled={!canEdit || skipIfSsnPopulated} /><Form.Toggle name="skipIfFullAddressPopulated" label={t(_temp6)} size="compact" disabled={!canEdit} /></div><VerifiedPrefillOutputs canEdit={canEdit} /></>;
    $[13] = canEdit;
    $[14] = enabledVerifiedPrefill;
    $[15] = isFirmEmployee;
    $[16] = skipIfSsnPopulated;
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10 || $[20] !== t4 || $[21] !== t9) {
    t11 = <Section title={t4}>{t9}{t10}</Section>;
    $[19] = t10;
    $[20] = t4;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  return t11;
};
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3($_1) {
  return $_1.collectData.person.verifiedPrefill.hint;
}
function _temp4($_2) {
  return $_2.skipSsn.label;
}
function _temp5($_3) {
  return $_3.skipSsn.tooltip;
}
function _temp6($_4) {
  return $_4.skipFullAddress.label;
}